import type { TransformFunctions } from '@sitecore/common';

export const businessUnit = 'nl';
export const countryCode = 'NL';
export const label = 'eneco';
export const name = 'nl-eneco-zakelijk';
export const uuid = 'HINok3';
export const transformFunctions: TransformFunctions = {};

/** Scopes Sanity page lookups to this container's own pages. `SANITY_SITE` overrides it. */
export const sanitySite = 'site-eneco-nl-zakelijk';
